import { render, staticRenderFns } from "./PsoriasisSummary.vue?vue&type=template&id=5d9a0d9c&scoped=true&"
import script from "./PsoriasisSummary.vue?vue&type=script&lang=js&"
export * from "./PsoriasisSummary.vue?vue&type=script&lang=js&"
import style0 from "./PsoriasisSummary.vue?vue&type=style&index=0&id=5d9a0d9c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9a0d9c",
  null
  
)

export default component.exports